import { StaticImage } from "gatsby-plugin-image"

import { Seo } from "@trueskin-web/components"
import { useTranslation } from "@trueskin-web/translations"

import FAQs from "../components/faqs"
import FeaturesCard from "../components/features-card"
import Hero from "../components/hero"
import IngredientsCarousel from "../components/ingredients-carousel"
import SuccessStoryCard from "../components/success-story-card"
import TestimonialCard from "../components/testimotional-card"
import { faq, plansV1 } from "../resources"

import Plans from "./plans"

const AntiAgingPlanSelectionV1 = () => {
  const { t } = useTranslation()

  return (
    <div sx={{ maxWidth: "468px", mx: "auto", pb: 4 }}>
      <Seo title={t("ChoosePlan.seoTitle")} />
      <Hero />
      <Plans resources={plansV1} />
      <TestimonialCard
        quote="Jede Formulierung wird individuell von unserem Ärzt:innen-Team entwickelt. Es handelt sich nicht um klassische Kosmetikprodukte, sondern um dermatologisch begleitete Pflege, die gezielt auf Dein Hautbild abgestimmt ist."
        authorName="Dr. Sarah Bechstein"
        authorTitle="Mitgründerin von FORMEL SKIN"
      />
      <IngredientsCarousel />
      <FeaturesCard />
      <SuccessStoryCard />
      <FAQs
        title="FAQs"
        items={faq}
        sx={{
          mb: 7,
        }}
      >
        <StaticImage
          src="../images/faq.webp"
          alt="Ärzten-apotheker"
          sx={{ width: "100%", mb: 4 }}
        />
      </FAQs>
    </div>
  )
}

export default AntiAgingPlanSelectionV1
